<!-- 编辑/网销库存商品 -->
<template>
    <el-dialog :close-on-click-modal="false" :title="title" :visible="dialogFormVisible" width="1000px" :show-close="true" :before-close="handleClose">
        <div id="SIgoodsEditPage" v-loading="dialogLoading" v-loading.fullscreen="false">
            <div class="form-main">
                <el-form :model="editShareInventoryData" :rules="rules" ref="editShareInventoryData" label-width="100px" class="form-ctn" :disabled="action == 'lookover'">
                    <div class="form-main">
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="汽配编码" prop="apCode">
                                    <el-input class="search-item" size="large" v-model="editShareInventoryData.apCode" :disabled="true"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="汽配互换码">
                                    <el-input class="search-item" size="large" v-model="editShareInventoryData.goodCode"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="汽配名称" prop="goodName">
                                    <el-input class="search-item" size="large" v-model="editShareInventoryData.goodName"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="适用车型" prop="autoSerise">
                                    <el-select
                                        :loading="loading"
                                        allow-create
                                        v-model="editShareInventoryData.autoSerise"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        placeholder="车型"
                                        :remote-method="searchAutoSerie"
                                        @visible-change="autoSerieVisibleChange($event)"
                                    >
                                        <el-option :loading="true" v-for="item in seriesList" :key="item.SeriesId" :label="item.SeriesName" :value="item.SeriesName"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="汽配分类" prop="cate">
                                    <el-select
                                        allow-create
                                        size="large"
                                        v-model="editShareInventoryData.cate"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        @visible-change="classifyVisibleChange($event)"
                                    >
                                        <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                            <div class="option-content">
                                                <div>{{ optionItem.Text }}</div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="汽配品牌" prop="brand">
                                    <el-select size="large" v-model="editShareInventoryData.brand" filterable clearable allow-create @visible-change="brandVisibleChange($event)">
                                        <el-option v-for="optionItem in brandList" :key="optionItem.Text" :label="optionItem.Text" :value="optionItem.Text">
                                            <div class="option-content">
                                                <div>{{ optionItem.Text }}</div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="成本价" prop="costPrice">
                                    <el-input v-model="editShareInventoryData.costPrice" class="search-item" size="large" placeholder :disabled="true"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="零售价" prop="marketPrice">
                                    <el-input v-model="editShareInventoryData.marketPrice" class="search-item" size="large" placeholder></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="批发价" prop="price">
                                    <el-input v-model="editShareInventoryData.price" class="search-item" size="large" placeholder></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="库存数">
                                    <el-input v-model="editShareInventoryData.inventory" :disabled="true" class="search-item" size="large" placeholder></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="网销库存数" prop="shareCount">
                                    <el-input
                                        v-model.number="editShareInventoryData.shareCount"
                                        class="search-item"
                                        size="large"
                                        placeholder
                                        @blur="inputBlur"
                                        @focus="inputFocus"
                                    ></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="网销价格" prop="sharePrice">
                                    <el-input
                                        v-model="editShareInventoryData.sharePrice"
                                        class="search-item"
                                        size="large"
                                        placeholder
                                        @blur="inputBlur"
                                        @focus="inputFocus"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="材质">
                                    <el-input v-model="editShareInventoryData.texture" class="search-item" size="large" placeholder></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="颜色">
                                    <el-input v-model="editShareInventoryData.color" class="search-item" size="large" placeholder></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="产地" prop="origin">
                                    <el-input v-model="editShareInventoryData.origin" class="search-item" size="large" placeholder></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="配件尺寸">
                                    <el-input v-model="editShareInventoryData.size" class="search-item" size="large" placeholder @blur="inputBlur" @focus="inputFocus"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="装箱规格">
                                    <el-input v-model="editShareInventoryData.PackingNum" class="search-item" size="large" placeholder="整箱商品的数量：/箱，/个，/盒…"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="重量(kg)" prop="quality">
                                    <el-input
                                        v-model="editShareInventoryData.quality"
                                        class="search-item"
                                        size="large"
                                        placeholder
                                        @blur="inputBlur"
                                        @focus="inputFocus"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class style="width: 700px">
                                <el-form-item label="包装尺寸" class="packageSize">
                                    长
                                    <input
                                        v-model.number="editShareInventoryData.Length"
                                        :disabled="action == 'lookover'"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        size="small"
                                        @blur="inputBlur"
                                        @focus="inputFocus"
                                    />
                                    &nbsp;宽
                                    <input
                                        v-model.number="editShareInventoryData.Width"
                                        :disabled="action == 'lookover'"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        size="small"
                                        @blur="inputBlur"
                                        @focus="inputFocus"
                                    />
                                    &nbsp;高
                                    <input
                                        v-model.number="editShareInventoryData.Height"
                                        :disabled="action == 'lookover'"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        size="small"
                                        @blur="inputBlur"
                                        @focus="inputFocus"
                                    />
                                    (cm)
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="单位" prop="unit">
                                    <el-select v-model="editShareInventoryData.unit" filterable allow-create placeholder @visible-change="unitVisibleChange($event)">
                                        <el-option v-for="item in unitList" :key="item.Value" :label="item.Value" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="主要图片" prop="mainImg">
                                    <uploadFile
                                        ref="uploadMainFile"
                                        type="EntpTempGoods"
                                        :disabled="action == 'lookover'"
                                        :limit="1"
                                        :initfileList="editShareInventoryData.mainImg ? [editShareInventoryData.mainImg] : []"
                                        @uploadSuccess="uploadMainSuccess"
                                        @handleRemove="handleMainRemove"
                                    ></uploadFile>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="辅助图片">
                                    <uploadFile
                                        ref="uploadMinorFile"
                                        type="EntpTempGoods"
                                        :disabled="action == 'lookover'"
                                        :multiple="true"
                                        :initfileList="editShareInventoryData.pictureList"
                                        @uploadSuccess="uploadMinorSuccess"
                                        @handleRemove="handleMinorRemove"
                                    ></uploadFile>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item" style="width: 100%; height: 100px">
                                <el-form-item label="备注">
                                    <el-input
                                        v-model="editShareInventoryData.goodDesc"
                                        rows="4"
                                        type="textarea"
                                        class="search-item form-item-remark"
                                        size="small"
                                        placeholder
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
                <el-button class="search-btn btn-primary" @click="close('close')">取 消</el-button>
                <el-button class="search-btn btn-primary" @click="askconfirm" v-if="action == 'edit'">提交审核</el-button>
                <el-button class="search-btn btn-primary" @click="editShareInventory" v-if="action == 'add'">提交审核</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import uploadFile from '@/components/common/uploadBtn.vue';
export default {
    name: 'SIgoodsEditPage',
    props: {
        dialogFormVisible: Boolean,
        propsGoodsId: String,
        action: String
    },
    components: { uploadFile },
    data() {
        let checkPositive = this.$util.checkPositive;
        let shareCount_validate = (rule, value, callback) => {
            if (!Number.isInteger(value)) {
                //input 不标识为number类型，输入数字永远不通过，我察
                callback(new Error('请输入数字值'));
            } else if (value <= 0) {
                callback(new Error('网销数必须大于零'));
                // } else if (value > this.editShareInventoryData.inventory) {
                //   //this.editShareInventoryData.inventory这个值如果在rule里面写识别不了，我察
                //   callback(new Error("网销数不能大于库存"));
            } else {
                callback();
            }
        };
        return {
            title: '添加网销商品',
            editShareInventoryData: {
                goodsRsId: '',
                goodsId: this.propsGoodsId,
                goodCode: '',
                goodName: '',
                goodDesc: '',
                mainImg: '',
                price: 0,
                marketPrice: 0,
                costPrice: 0,
                apCode: '',
                quality: 0,
                brand: '',
                origin: '',
                color: '',
                texture: '',
                unit: '',
                inventory: 0,
                cate: '',
                warningUpperLimit: '',
                warningLowerLimit: '',
                autoSerise: '',
                shareCount: 0,
                sharePrice: 0,
                pictureList: [],
                size: '', //配件尺寸
                Length: 0,
                Width: 0,
                Height: 0,
                PackageSize: '', //包装尺寸
                PackingNum: '' //装箱规格
            },
            loading: false,
            dialogLoading: true,
            brandList: [],
            apCategoryList: [],
            seriesList: [],
            unitList: [],
            rules: {
                apCode: [{ required: true, message: '请输入汽配编码', trigger: 'blur' }],
                goodName: [{ required: true, message: '请输入汽配名称', trigger: 'blur' }],
                autoSerise: [{ required: true, message: '请输入适用车型', trigger: 'blur' }],
                cate: [{ required: true, message: '请选择汽配分类', trigger: 'change' }],
                brand: [{ required: true, message: '请选择汽配品牌', trigger: 'change' }],
                mainImg: [{ required: true, message: '请补充主图', trigger: 'change' }],
                unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
                quality: [{ validator: checkPositive, trigger: 'blur' }],
                costPrice: [
                    { required: true, message: '请输入成本价', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                marketPrice: [
                    { required: true, message: '请输入零售价', trigger: 'blur' },
                    {
                        validator: function (rule, value, callback) {
                            if (value <= 0) {
                                callback(new Error('零售价必须大于零'));
                            } else if (!Number(value)) {
                                callback(new Error('零售价必须是数值'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                price: [
                    { required: true, message: '请输入批发价', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                // inventory: [
                //   { required: true, message: "请输入库存数", trigger: "blur" },
                //   {
                //     validator: function(rule, value, callback) {
                //       if (value <= 0) {
                //         callback(new Error("库存数必须大于零"));
                //       } else {
                //         callback();
                //       }
                //     },
                //     trigger: "blur"
                //   }
                // ],
                sharePrice: [
                    { required: true, message: '请输入网销价', trigger: 'blur' },
                    {
                        validator: function (rule, value, callback) {
                            if (value <= 0) {
                                callback(new Error('网销价必须大于零'));
                            } else if (!Number(value)) {
                                callback(new Error('网销价必须是数值'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                shareCount: [
                    { required: true, message: '请输入网销数', trigger: 'blur' },
                    { validator: shareCount_validate, trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {},
    computed: {},
    watch: {
        propsGoodsId: {
            handler(newVal, oldVal) {
                this.dialogLoading = true;
                if (newVal) {
                    this.editShareInventoryData.goodsId = newVal;
                    this.clearGoodsDate();
                    this.getEnterprisePart();
                }
            },
            immediate: true
        },
        action: function (val) {
            let that = this;
            switch (val) {
                case 'add':
                    that.title = '添加网销商品';
                    break;
                case 'edit':
                    that.title = '编辑网销商品';
                    break;
                case 'lookover':
                    that.title = '网销商品详情';
                    break;
                default:
                    break;
            }
        }
    },
    methods: {
        // 上传主要图片成功后执行
        uploadMainSuccess(res) {
            this.editShareInventoryData.mainImg = res;
        },
        // 删除主要图片
        handleMainRemove() {
            this.editShareInventoryData.mainImg = '';
        },
        // 上传次要图片成功后执行
        uploadMinorSuccess(res) {
            this.editShareInventoryData.pictureList.push(res);
        },
        // 删除次要图片
        handleMinorRemove(file) {
            let fileUrl = file;
            let _pictureList = this.editShareInventoryData.pictureList;
            for (let i = 0; i < _pictureList.length; i++) {
                if (_pictureList[i] == fileUrl) {
                    _pictureList.splice(i, 1);
                }
            }
        },
        //获取商品详情
        getEnterprisePart() {
            this.$util
                .axiosGet({
                    url: '/api/ShareInventory/GetShareGoodsDetail',
                    data: {
                        goodsId: this.propsGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        let data = res.data;
                        //辅助图
                        if (data.PictureList) {
                            this.editShareInventoryData.pictureList = data.PictureList;
                        } else {
                            this.editShareInventoryData.pictureList = [];
                        }
                        //主图
                        if (data.MainImg != '') {
                            this.editShareInventoryData.mainImg = data.MainImg;
                        } else {
                            this.editShareInventoryData.mainImg = '';
                        }
                        this.editShareInventoryData.goodsId = this.propsGoodsId;
                        this.editShareInventoryData.goodName = data.GoodName;
                        this.editShareInventoryData.goodCode = data.GoodCode;
                        this.editShareInventoryData.goodDesc = data.GoodDesc;
                        this.editShareInventoryData.price = data.Price;
                        this.editShareInventoryData.marketPrice = data.MarketPrice;
                        this.editShareInventoryData.costPrice = data.CostPrice;
                        this.editShareInventoryData.apCode = data.APCode;
                        this.editShareInventoryData.size = data.Size;
                        this.editShareInventoryData.quality = data.Quality;
                        this.editShareInventoryData.brand = data.Brand;
                        this.editShareInventoryData.origin = data.Origin;
                        this.editShareInventoryData.color = data.Color;
                        this.editShareInventoryData.texture = data.Texture;
                        this.editShareInventoryData.unit = data.Unit;
                        this.editShareInventoryData.inventory = data.Inventory;
                        this.editShareInventoryData.cate = data.Cate;
                        this.editShareInventoryData.autoSerise = data.AutoSerise;
                        this.editShareInventoryData.shareCount = data.ShareCount;
                        this.editShareInventoryData.sharePrice = data.SharePrice;
                        this.editShareInventoryData.PackingNum = data.PackingNum;

                        if (data.PackageSize) {
                            let PackageSizeArr = data.PackageSize.split('*');
                            this.editShareInventoryData.Length = !isNaN(PackageSizeArr[0]) ? PackageSizeArr[0] : 0;
                            this.editShareInventoryData.Width = !isNaN(PackageSizeArr[1]) ? PackageSizeArr[1] : 0;
                            this.editShareInventoryData.Height = !isNaN(PackageSizeArr[2]) ? PackageSizeArr[2] : 0;
                        }
                        this.dialogLoading = false;
                    }
                })
                .catch(err => {
                    this.dialogLoading = false;
                });
        },

        //获取品牌分类
        getEnterprisePartBrandList() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        // 搜车型
        searchAutoSerie(key) {
            this.loading = true;
            this.$util.searchAutoSerie(key).then(data => {
                this.seriesList = data;
                this.loading = false;
            });
        },
        //获取汽配分类
        getEntpApCategoryList() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.apCategoryList = data;
                })
                .catch(() => {});
        },
        //获取单位
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length <= 1) that.getConfigData();
            }
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.getEnterprisePartBrandList();
            }
        },
        //当汽配分类下拉框出现时触发
        classifyVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.getEntpApCategoryList();
            }
        },
        //当车系下拉框出现时触发
        autoSerieVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie('');
            }
        },
        //询问是否确认提交
        askconfirm() {
            let that = this;
            that.$confirm('提交审核后需要重新审核商品，您确定要提交', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.editShareInventory();
                })
                .catch(err => {});
        },
        //添加商品到网销库存前-编辑补充商品资料
        editShareInventory() {
            this.$refs['editShareInventoryData'].validate(valid => {
                let that = this;
                if (valid) {
                    if (!that.editShareInventoryData.Size) that.editShareInventoryData.Size = 0;
                    if (!that.editShareInventoryData.Length) that.editShareInventoryData.Length = 0;
                    if (!that.editShareInventoryData.Width) that.editShareInventoryData.Width = 0;
                    if (!that.editShareInventoryData.Height) that.editShareInventoryData.Height = 0;
                    that.editShareInventoryData.PackageSize =
                        that.editShareInventoryData.Length + '*' + that.editShareInventoryData.Width + '*' + that.editShareInventoryData.Height;
                    this.dialogLoading = true; //开罩
                    this.$util
                        .axiosPost({
                            url: '/api/ShareInventory/EditShareInventory',
                            data: this.editShareInventoryData,
                            hideLoading: true
                        })
                        .then(res => {
                            this.dialogLoading = false;
                            if (res.errcode == 0) {
                                this.$util.successMsg('提交成功');
                                this.close('addsuccess');
                            } else {
                                this.$util.errorMsg(res.errmsg);
                            }
                        })
                        .catch(err => {
                            this.dialogLoading = false;
                        });
                }
            });
        },
        handleClose() {
            this.close('close');
        },
        //关闭商品编辑dialog
        close(action) {
            this.$refs['editShareInventoryData'].clearValidate(); //清空表单验证信息
            this.$emit('closeDialogForm', {
                goodsId: this.propsGoodsId,
                action: action
            });
        },
        //清空商品参数
        clearGoodsDate() {
            this.editShareInventoryData = {
                goodsRsId: '',
                goodsId: '',
                goodCode: '',
                goodName: '',
                goodDesc: '',
                mainImg: '',
                price: '',
                marketPrice: '',
                costPrice: '',
                apCode: '',
                quality: '',
                brand: '',
                origin: '',
                color: '',
                texture: '',
                unit: '',
                inventory: '',
                cate: '',
                warningUpperLimit: '',
                warningLowerLimit: '',
                autoSerise: '',
                shareCount: 0,
                sharePrice: 0,
                pictureList: [],
                size: '', //配件尺寸
                Length: 0,
                Width: 0,
                Height: 0,
                PackageSize: '', //包装尺寸
                PackingNum: '' //装箱规格
            };
        },
        inputBlur(event) {
            if (!event.target.value) event.target.value = 0;
        },
        inputFocus(event) {
            if (event.target.value == 0) event.target.value = '';
        }
    }
};
</script>
<style lang="less" scoped>
.form-main {
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.form-line {
    display: flex;
    flex-direction: row;
}
.form-item {
    width: 350px;
    .el-input {
        width: 200px;
    }
    .el-select {
        width: 200px;
    }
}
.form-item-remark {
    textarea {
        height: 100px;
    }
    .el-textarea {
        height: 100px;
    }
    .el-textarea__inner {
        height: 100px;
    }
}
</style>
<style lang="less">
//辅助图片出现滚条
.el-upload-list {
    max-height: 120px;
    overflow-y: auto;
}
.packageSize {
    input {
        outline: none;
        height: 36px;
        line-height: 36px;
        border-radius: 5px;
        border: none;
        border: 1px solid #dcdfe6;
        text-align: center;
        width: 100px;
    }
    input:disabled {
        color: #c0c4cc;
        cursor: not-allowed;
        background-color: #f5f7fa;
    }
}
</style>
